/*eslint-disable */
define(function(require) {
    var $ =  require('jquery');
    var URI = require('URIjs/URI');
    var { initialiseFacebook, getFacebookAuthToken } = require("common/facebook-api/facebook-api-login");

    var $page;
    var $loginForm;
    var login;

    var $popup;

    function handleFacebookButtonClick() {
      $popup.find('.facebook-button').on('click', function () {
        getFacebookAuthToken()
          .then((accessToken) => {
            closePopup();
            login({
              $loginForm,
              facebookAccessToken: accessToken
            })
          })
          .catch(closePopup)
      });
    }

    function closePopup() {
        $popup.popup('close');
    }

    function setCreatePasswordLink(requestPasswordToken) {
        var $createPasswordButton = $popup.find('.create-password-button');
        var uri = new URI($createPasswordButton.attr('href'));

        uri.query({token: requestPasswordToken});
        $createPasswordButton.attr('href', uri.toString());
    }

    return function($loginForm_, requestPasswordToken, login_) {
        $page = $.mobile.pageContainer.pagecontainer('getActivePage');
        $popup = $("#facebook-no-password-popup-" + $page.attr("id"));

        $loginForm = $loginForm_;
        login = login_;

        initialiseFacebook();
        handleFacebookButtonClick();
        $page.find('.close a').on('click', closePopup);
        setCreatePasswordLink(requestPasswordToken);

        $popup.popup('open');
    };
});
